import PaymentOrShipmentIcon from './PaymentOrShipmentIcon'

export default PaymentOrShipmentIcon
